import React from 'react';
import { BankIDComponent } from '../BankIDComponent';

export interface BankIDAuthProps {
    onClose: () => void;
    onSuccess?: (userData: any) => void;
    mode: 'login' | 'signup';
    accountType?: 'freelancer' | 'business';
    title?: string;
    subtitle?: string;
    className?: string;
}

const BankIDAuth: React.FC<BankIDAuthProps> = (props) => {
    return <BankIDComponent {...props} />;
};

export default BankIDAuth;
